module.exports = __webpack_public_path__ + "img/speaker-profile-element2.0c412ab8.png";